export default function TestimonialSection() {
  return (
    <section className="bg-[#F5F9F5] py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm text-[#00A000] font-bold tracking-widest uppercase mb-3">VOICE</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] leading-tight">
            何をやってもやめられなかった<br />
            夜のお菓子を、無理なく<br className="sm:hidden" />控えられるようになりました
          </h2>
        </div>

        <div className="bg-white rounded-2xl border border-[#E0F0E0] p-8">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#E8F8E8] overflow-hidden flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/b17b44323c7eb3fa784eb391778099fd/a47dab33eafbc880c3ba9e6493442fee.png"
                alt="お客様の声"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <p className="text-[#1a1a1a] font-bold text-sm">30代 / 女性 / 東京在住</p>
              <p className="text-[#888] text-xs">会社員 / 週2日在宅勤務</p>
            </div>
            <div className="ml-auto flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <span key={i} className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-sm text-yellow-400"></i>
                </span>
              ))}
            </div>
          </div>

          <blockquote className="text-[#444] text-sm leading-relaxed space-y-3">
            <p>ストレスがかかると甘いものを食べてしまう習慣があり、ずっとやめたいと思いながらもやめられずに悩んでいました。お菓子を買わないと決意したり、置き換え食品を試したり、記録をつけたりと、これまでいろいろな方法を試しましたが、寝不足や強いストレスがあると、結局買って食べてしまう。そんな状態が何年も続いていました。</p>
            <p>あるとき、ふと鏡を見たときに、「なんだか前より肌の調子がよくないかも」と感じたんです。夜に甘いものを食べる日が続くと、肌荒れしやすくなったり、吹き出物やニキビが気になったりして、少しずつ体重も増えてきました。このままの生活を続けていたら、見た目の印象までどんどん変わってしまうかもしれないと思い、さすがにまずいと感じるようになりました。</p>
            <p>「今度こそやめよう」と思っても、忙しかったりストレスがたまったりすると、結局また食べてしまう。その繰り返しで、自分ひとりではなかなか変えられないと感じていました。そんなときにこのサービスを知ったのですが、正直、最初はそこまで期待していませんでした。</p>
            <p>しかし、これまで2日も続かなかった甘いものを控えることが、YAMEBIを使い始めてからは前よりずっと続けやすくなりました。<strong>そもそも甘いものを購入できない環境になるので、</strong>「買おうかな、どうしようかな」と迷う場面そのものが減り、思っていた以上にラクだったんです。正直、<strong>最初はどこかに抜け道があるのではと思っていましたが、実際にはそういう余地もほとんどなく、</strong>気づけば1週間、そして1ヶ月と経っていました。買うかどうか迷う時間や、食べた後の自己嫌悪がなくなったことで、精神的なストレスもかなり減ったように感じています。</p>
            <p>最初の数週間は食べたい気持ちとの葛藤も少しありましたが、今は無理なく続けられるようになりました。</p>
          </blockquote>

          <p className="text-[#999] text-xs mt-5 pt-4 border-t border-[#E0F0E0]">
            ※個人の感想です。感じ方や結果には個人差があります。
          </p>
        </div>
      </div>
    </section>
  );
}
